import type { ReactNode } from "react";

interface IMenuTitleProps {
  children: ReactNode;
}

export default function MenuTitle({ children }: IMenuTitleProps) {
  return (
    <li className="py-2">
      <h6 className="m-0 text-xs font-bold uppercase text-slate-700 dark:text-slate-500">{children}</h6>
    </li>
  );
}
